// extracted by mini-css-extract-plugin
export default {"image":"RX-z","loaded":"SX-z"};